// import { FiMenu, FiUser, FiSearch } from 'react-icons/fi';
// import ThemeToggle from './ThemeToggle';
// import logo from '../assets/NCCFLogo.jpg';
// import ncflogo from '../assets/cooperatives.jpg';
// import { useNavigate, useLocation } from "react-router-dom";
// import React, { useState, useEffect, useRef } from "react";

// export default function Navbar({ toggleSidebar }) {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [isSmall, setIsSmall] = useState(window.innerWidth < 1024);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Handle window resize
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//       setIsSmall(window.innerWidth < 1024);
//     };

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleLogout = () => {
//     // Clear localStorage / token if you store authentication
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");

//     // Navigate to login page
//     navigate("/login");
//   };

//   return (
//     <header className="relative flex items-center justify-between py-4 px-4 sm:px-6 bg-[#1B0063] text-white dark:bg-[#1B0063] shadow-md">
// {/* Left: Menu + Main Logo + Headings */}
// <div className="flex items-center gap-3 flex-shrink-0 z-10">
//   <button
//     className="md:hidden"
//     onClick={toggleSidebar}
//     aria-label="Toggle sidebar"
//   >
//     <FiMenu size={24} />
//   </button>

//   {/* White container for logo + headings */}
//   <div className="flex items-center bg-white rounded-md px-3 py-2 shadow">
// <img
//   src={logo}
//   alt="Logo"
//   className="h-24 w-auto object-contain flex-shrink-0"
// />

//     {/* Headings block - hide on mobile */}
//     {!isMobile && (
//       <div className="leading-tight ml-3">
//         <h1 className="text-[#0056D2] text-[13px] font-bold">
//           भारतीय राष्ट्रीय उपभोक्ता सहकारी संघ मर्यादित
//         </h1>
//         <p className="text-black text-[12px] font-medium">
//           (उपभोक्ता मामले, खाद्य एवं सार्वजनिक वितरण मंत्रालय)
//         </p>
//         <p className="text-black text-[11px] font-semibold">
//           भारत सरकार
//         </p>
//         <h2 className="text-[#0056D2] text-[13px] font-semibold uppercase mt-1">
//           National Cooperative Consumers&apos; Federation of India Limited
//         </h2>
//         <p className="text-black text-[12px] font-medium">
//           (Ministry of Consumer Affairs, Food and Public Distribution)
//         </p>
//         <p className="text-black text-[11px] font-semibold">
//           Government of India
//         </p>
//       </div>
//     )}
//   </div>
// </div>

//       {/* Right: Theme Toggle + Small Logo + User Icon */}
//       <div className="flex items-center gap-4 flex-shrink-0 z-10">
// {/* Only show cooperatives logo on larger screens */}
// {!isSmall && (
//   <img
//     src={ncflogo}
//     alt="Mini Logo"
//     className="h-24 w-auto object-contain"
//   />
// )}
//         <ThemeToggle />
//         {/* User Icon with Dropdown */}
//         <div className="relative">
//           <button
//             onClick={() => setDropdownOpen(!dropdownOpen)}
//             className="p-2 rounded-full hover:bg-white/10"
//           >
//             <FiUser size={20} />
//           </button>

//           {/* Dropdown Menu */}
//           {dropdownOpen && location.pathname !== "/login" && (
//             <div className="absolute right-0 mt-2 w-32 bg-white text-gray-800 rounded-md shadow-lg py-2">
//               <button
//                 onClick={handleLogout}
//                 className="block w-full text-left px-4 py-2 hover:bg-gray-100"
//               >
//                 Logout
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

import { FiMenu, FiUser } from 'react-icons/fi';
import logo from '../assets/NCCFLogo.jpg';
import ncflogo from '../assets/cooperatives.jpg';
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../axiosInstance';

export default function Navbar({ toggleSidebar }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isSmall, setIsSmall] = useState(window.innerWidth < 1024);
  const [user, setUser] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsSmall(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch user profile
  const profileFetchedRef = useRef(false);

  useEffect(() => {
    const fetchProfile = async () => {
      // Only fetch profile if it hasn't been fetched already
      if (profileFetchedRef.current) return;
      profileFetchedRef.current = true;

      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const res = await axiosInstance.get(`user/profile`);
        setUser(res.data);
      } catch (err) {
        console.error('Error fetching profile:', err);
      }
    };
    fetchProfile();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <header className="relative flex items-center justify-between py-4 px-4 sm:px-6 bg-[#1B0063] text-white dark:bg-[#1B0063] shadow-md">
      {/* Left: Menu + Main Logo + Headings */}
      <div className="flex items-center gap-3 flex-shrink-0 z-10">
        <button
          className="md:hidden"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <FiMenu size={24} />
        </button>

        {/* White container for logo + headings */}
        <div className="flex items-center bg-white rounded-md px-3 py-2 shadow">
          <img
            src={logo}
            alt="Logo"
            className="h-24 w-auto object-contain flex-shrink-0"
          />

          {/* Headings block - hide on mobile */}
          {!isMobile && (
            <div className="leading-tight ml-3">
              <h1 className="text-[#0056D2] text-[13px] font-bold">
                भारतीय राष्ट्रीय उपभोक्ता सहकारी संघ मर्यादित
              </h1>
              <p className="text-black text-[12px] font-medium">
                (उपभोक्ता मामले, खाद्य एवं सार्वजनिक वितरण मंत्रालय)
              </p>
              <p className="text-black text-[11px] font-semibold">भारत सरकार</p>
              <h2 className="text-[#0056D2] text-[13px] font-semibold uppercase mt-1">
                National Cooperative Consumers&apos; Federation of India Limited
              </h2>
              <p className="text-black text-[12px] font-medium">
                (Ministry of Consumer Affairs, Food and Public Distribution)
              </p>
              <p className="text-black text-[11px] font-semibold">
                Government of India
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Right: Theme Toggle + Small Logo + User Icon */}
      <div className="flex items-center gap-4 flex-shrink-0 z-10">
        {/* Only show cooperatives logo on larger screens */}


        {/* User Icon with Dropdown */}
        {location.pathname !== '/login' && (
          <div className="relative flex items-center gap-2">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="p-2 rounded-full hover:bg-white/10"
            >
              <FiUser size={20} />
            </button>

            {/* Dropdown Menu */}
            {dropdownOpen && (
              <div className="absolute right-0 top-full mt-2 w-40 bg-white text-gray-800 rounded-md shadow-lg py-2 z-50">
                <button
                  onClick={() => {
                    navigate('/profile');
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Profile
                </button>
                <button
                  onClick={() => {
                    navigate('/update-password');
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Update Password
                </button>
                <button
                  onClick={() => {
                    handleLogout();
                    setDropdownOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
